/** Statuses grouped by color token. Add new statuses to the appropriate group. */
const STATUS_COLORS = {
  primary: ['scheduled', 'ready', 'rescheduled', 'initiated'],
  purple: ['started', 'progress', 'in_progress', 'in_room', 'processing'],
  success: [
    'success',
    'active',
    'approved',
    'finalized',
    'signed_and_locked',
    'signed',
    'created',
    'confirmed',
    'accepted',
    'paid',
    'balance_paid',
    'checked_in',
    'cc_on_file',
    'appointment_ended',
    'clinical_note_locked',
    'superbill_scrubbed',
    'claim_paid',
    'completed',
    'complete',
    'seen',
    'approval'
  ],
  danger: [
    'cancelled',
    'canceled',
    'rejected',
    'declined',
    'denied',
    'failed',
    'balance_not_paid',
    'unconfirmed',
    'not_checked_in',
    'no_show',
    'no_cc_on_file',
    'not_arrived',
    'clinical_note_not_started',
    'superbill_not_created',
    'claim_not_created',
    'claim_rejected',
    'claim_denied',
    'voided',
    'deleted',
    'not_completed',
    'aborted'
  ],
  warning: [
    'needs_review',
    'expired',
    'not_started',
    'out_of_stock',
    'pending',
    'requested',
    'balance_partially_paid',
    'partially_checked_in',
    'arrived_waiting',
    'clinical_note_started',
    'superbill_not_scrubbed',
    'claim_ready',
    'claim_acknowledged',
    'claim_pending',
    'sent',
    'refunded',
    'partially_refunded',
    'partially_completed',
    'in_lobby',
    'pending_arrival',
    'temporary_deactivation'
  ],
  neutral: [
    'used',
    'draft',
    'awaiting_co_sign',
    'unread',
    'read',
    'awaiting_signature',
    'inactive',
    'discontinued',
    'acknowledged',
    'archived',
    'no_claim',
    'no_payment',
    'claim_no_payment',
    'no_show',
    'cc_not_needed'
  ]
};

/** @type {Record<string, string>} */
export const STATUS_COLOR_MAP = Object.fromEntries(
  Object.entries(STATUS_COLORS).flatMap(([color, statuses]) =>
    statuses.map((status) => [status, color])
  )
);
